import { Injectable, HostListener } from '@angular/core';

import { ViewportScroller } from '@angular/common';

import { of, Subject, BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { tap, switchMap, skip, share, map, filter, shareReplay, distinctUntilChanged, takeUntil, takeWhile, take, throttleTime, animationFrames } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  public scrollPosition$ = new BehaviorSubject<number>(0);
  public isInView$ = new BehaviorSubject<boolean>(false);
  public scrollIntoView$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private stopWatchScroll$: Subject<void> = new Subject();
  private scrollObservable$: any = null;

  constructor(
    readonly viewportScroller: ViewportScroller
  ) {}

  /* CONTROLS */

  public setScrollIntoView = (id: string): void => {
    console.log('**** ScrollService scroll setScrollIntoView **** id ', id);
    this.scrollIntoView$.next(id);
  };

  public scrollToPosition = (pos: [number, number]): void => {
    console.log('ScrollService scrollToPosition pos ', pos);

    this.viewportScroller.scrollToPosition(pos);
  };

  /* SET */

  public isInView = (state: any) => {
    this.isInView$.next(state.isInView);
    
  };

  public getScrollPosition = (): [number, number] => this.viewportScroller.getScrollPosition();


  /* SCROLL DIRECTIVE */

  // watch scroll on scroll event from scroll directive
  public watchScroll = (subscribeScrollDirective:Function): void => {
    //console.log('ScrollService watchScroll subscribeScrollDirective ', subscribeScrollDirective);
    //this.subscribeScrollDirective = subscribeScrollDirective;

    this.scrollObservable$ = this.watchScrollPosition(subscribeScrollDirective);
    this.scrollObservable$.subscribe();
    
  };

  /* PRIVATE */

  private watchScrollPosition = (subscribeScrollDirective:Function): Observable<number> => animationFrames().pipe(
    map(event => this.viewportScroller.getScrollPosition()[1]),
    //tap(scroll => console.log('ScrollService watchScrollPosition scroll ', scroll)),
    //tap(scroll => console.log('ScrollService watchScrollPosition this.scrollPosition$.value ', this.scrollPosition$.value)),
    tap(scroll => {
      if (scroll !== this.scrollPosition$.value) {
        this.scrollPosition$.next(scroll);
      }
      else {
        this.scrollStoped();
        subscribeScrollDirective();
      }
    }),
    takeUntil(this.stopWatchScroll$),
  );

  private scrollStoped = (): void => {
    //console.log('ScrollService scrollStoped ');

    this.stopWatchScroll$.next();
    //this.stopWatchScroll$.complete();
    this.scrollObservable$ = null;
    //this.subscribeScrollDirective();
    //this.subscribeScrollDirective = false;
  };
}
